import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ProductIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 10.056 16.376"
    >
      <defs>
        <clipPath>
          <rect width="10.056" height="16.376" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <rect
            width="3.562"
            height="1.904"
            transform="translate(3.247 0.75)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M8.981,5.361,6.809,2.65H3.247L1.075,5.361a1.422,1.422,0,0,0-.312.889L.75,14.509a1.117,1.117,0,0,0,1.117,1.117H8.19a1.117,1.117,0,0,0,1.116-1.117L9.294,6.25A1.427,1.427,0,0,0,8.981,5.361Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <line
            x2="7.619"
            transform="translate(1.375 5.859)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
